import React from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { IoMdArrowForward } from "react-icons/io";


const Correct = ({ message, handleNextPage }) => {
  return (
    <div className='correct-answer'>
        <p><FaCheckCircle /> {message}</p>
        <button className='button button-primary' onClick={handleNextPage}>Siguiente pregunta <IoMdArrowForward /></button>
    </div>
  );
};

export default Correct;